import React, { Dispatch, useMemo } from 'react';
import { PostScheduleFilterAction } from '../../../models/post';
import { PostQueueCountResult, SocialProfileFieldsFragment } from '../../../models/graphql';
import { FilterItemGroup } from '../FilterItemGroup';
import { FilterItem } from '../FilterItem';
import { SocialProfile } from '../../socialProfiles/SocialProfile';
import { profilesHelpers } from '../../../modules/Settings/Profiles/Profiles.helpers';
import { PostScheduleHelpers } from '../../../modules/Publish/PostSchedule/postScheduleHelpers';

export type PostSocialProfilesFilterGroupViewProps = {
  profiles: SocialProfileFieldsFragment[];
  loading: boolean;
  dispatchFilters: Dispatch<PostScheduleFilterAction>;
  activeFilterId?: string;
  queueCounts: PostQueueCountResult;
};

export const PostSocialProfilesFilterGroupView = (props: PostSocialProfilesFilterGroupViewProps): JSX.Element => {
  const { queueCounts } = props; // useContext(QueueCountContext);
  const setSelectedFilter = (id: string) => {
    props.dispatchFilters({ type: 'profile', payload: { data: id, fetchPosts: true } });
  };

  const counts = useMemo(() => PostScheduleHelpers.getQueueCounts(queueCounts, 'socialProfiles'), [queueCounts]);

  const filterItems = props.profiles.map((profile, index) => {
    const provider = profilesHelpers.mapOAuthFromTypename(profile.__typename);
    const network = profilesHelpers.mapNetworkFromTypename(profile.__typename);

    return (
      <FilterItem
        selected={props.activeFilterId === profile.id}
        loading={props.loading}
        key={`profileFilter.${profile.id}.${index}`}
        count={counts[profile.id] ?? 0}
        setSelectedHandler={() => setSelectedFilter(profile.id)}>
        <div>
          <SocialProfile
            size={'small'}
            label={true}
            disconnected={!profile.connected}
            socialProfile={{
              id: profile.id,
              name: profile.displayName,
              provider: provider,
              network: network,
              genericProfile: profile.__typename === 'GenericSocialProfile' ? profile.genericProfile : undefined
            }}
            image={profile.photoUrl}
          />
        </div>
      </FilterItem>
    );
  });

  return <FilterItemGroup title={'Filter By Profile'}>{filterItems}</FilterItemGroup>;
};
